module.exports = __webpack_public_path__ + "static/media/weather_or_not_logo.5301f584.png";